import { t } from 'i18next';

import { ErrorResponseErrorItemCodeTiledModel } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeTiledModel, string> => ({
  'tiled_model:not_found': t('tiledModel.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Avbildningen kunde inte hittas.',
  }),
  'tiled_model:user_unauthorized': t('tiledModel.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till avbildningen.',
  }),
  'tiled_model:export_not_supported': t('tiledModel.exportNotSupported', {
    ns: 'apiErrorCodes',
    defaultValue: 'Avbildningen kan inte exporteras ännu.',
  }),
});
